(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ipeqakids-unicorn-pair"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ipeqakids-unicorn-pair')) {
    customElements.define('ipeqakids-unicorn-pair', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.variantSelect = this.form.elements.lamp_variant;
        this.nameInput = this.form.elements.lamp_name;
        this.button = this.form.querySelector('button');
        this.errorElement = this.querySelector('[role="alert"]');
        this.buttonLabel = this.button.textContent;
        this.variantSelect.addEventListener('change', () => {
          const option = this.variantSelect.selectedOptions[0];
          this.querySelector('[data-original-price]').textContent = option.dataset.price;
          this.querySelector('[data-offer-price]').textContent = option.dataset.offer;
        });
        this.nameInput.addEventListener('input', () => this.nameInput.setCustomValidity(''));
        this.form.addEventListener('submit', event => this.addPair(event));
      }
      showError(message) {
        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
      }
      async addPair(event) {
        event.preventDefault();
        if (this.busy) return;
        this.errorElement.hidden = true;
        const mainForm = document.getElementById(this.dataset.formId);
        const info = document.getElementById('ProductInfo-' + this.dataset.sectionId);
        const sizeSelect = info?.querySelector('[id^="IpeqakidsSize-"]');
        if (sizeSelect && (!sizeSelect.value || sizeSelect.selectedOptions[0]?.disabled)) {
          this.showError(this.dataset.sizeError);
          sizeSelect.focus();
          return;
        }
        const name = this.nameInput.value.trim();
        if (!name) {
          this.nameInput.setCustomValidity(this.dataset.nameError);
          this.nameInput.reportValidity();
          return;
        }
        const mainButton = mainForm?.querySelector('[name="add"]');
        const variantInput = mainForm?.querySelector('[name="id"]');
        if (!variantInput?.value || variantInput.disabled || mainButton?.disabled || mainButton?.getAttribute('aria-disabled') === 'true') {
          this.showError(this.dataset.unavailable);
          return;
        }
        const formData = new FormData(mainForm);
        const dress = { id:Number(variantInput.value), quantity:Number(formData.get('quantity') || 1), properties:{} };
        for (const [key,value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') dress.properties[match[1]] = value;
        }
        if (formData.get('selling_plan')) dress.selling_plan = formData.get('selling_plan');
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.adding;
        this.setAttribute('aria-busy','true');
        try {
          const response = await fetch(this.dataset.addUrl, {
            method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[dress,{id:Number(this.variantSelect.value),quantity:1,properties:{'Yazılacak isim':name}}]})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          this.showError(error.message || this.dataset.error);
          this.busy = false;
          this.button.disabled = false;
          this.button.textContent = this.buttonLabel;
          this.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
